import type { FieldConfig } from '@/mocks/questionnaire';
import { chipClass } from '@/pages/home/components/fields/styles';

interface MultiChipsFieldProps {
  field: FieldConfig;
  value: string[];
  onChange: (value: string[]) => void;
}

export default function MultiChipsField({ field, value, onChange }: MultiChipsFieldProps) {
  const toggle = (label: string) => {
    const isNone = label === '无';
    if (value.includes(label)) {
      onChange(value.filter((item) => item !== label));
      return;
    }
    if (isNone) {
      onChange(['无']);
      return;
    }
    onChange([...value.filter((item) => item !== '无'), label]);
  };

  return (
    <div>
      <span className="block text-sm font-semibold text-foreground-900 mb-2">
        {field.label}
        {field.hint ? (
          <span className="text-xs font-normal text-foreground-400 ml-1">{field.hint}</span>
        ) : null}
      </span>
      <div className="flex flex-wrap gap-2">
        {(field.options || []).map((option) => (
          <button
            key={option.value}
            type="button"
            onClick={() => toggle(option.label)}
            className={chipClass(value.includes(option.label))}
          >
            {option.label}
          </button>
        ))}
      </div>
      <input type="hidden" name={field.name} value={value.join('、')} readOnly />
    </div>
  );
}